// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-portfolio----portfolio-page-module---container---3Gp9y","drag":"src-components-portfolio----portfolio-page-module---drag---1thzN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/portfolio-page.module.scss
// module id = 366
// module chunks = 36434998819415 120690779865315